import { CategoryRepository } from "../../../../data/repository/category/CategoryRepository";
import { ProductRepository } from "../../../../data/repository/product/ProductRepository";
import { Category } from "../../../model/Category";
import { Product } from "../../../model/Product";
import { ResponseState, State } from "../../../model/ResponseState";

export interface GetAllProductsUseCase {
  invoke: () => Promise<ResponseState<Array<Product>>>;
}

export class GetAllProductsUseCaseImpl implements GetAllProductsUseCase {
  private repo: ProductRepository;

  constructor(repo: ProductRepository) {
    this.repo = repo;
  }

  async invoke(): Promise<ResponseState<Array<Category>>> {
    try {
      let response = await this.repo.getAll();
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
